import { GearSix } from "@phosphor-icons/react";
import { useState } from "react";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Licenses } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import useAvailableLicensesCount from "common/hooks/useAvailableLicensesCount";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { WorkspaceAccount } from "common/types";

import DesktopDropdown from "./DesktopDropdown";
import MobileDrawer from "./MobileDrawer";

import type { MANAGE_ACCOUNTS_ACTIONS } from "../../constants";

export default function ManageAccounts({
  selectedAccounts,
}: {
  selectedAccounts: WorkspaceAccount[];
}) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<keyof typeof MANAGE_ACCOUNTS_ACTIONS>();
  const [isLicensesOpen, setIsLicensesOpen] = useState(false);
  const { availableLicensesCount } = useAvailableLicensesCount();

  const noLicenseAccounts = selectedAccounts.filter(
    ({ license, type }) => type === "user" && !license,
  );

  function onActionChange(action: keyof typeof MANAGE_ACCOUNTS_ACTIONS) {
    if (
      action === "seats" &&
      availableLicensesCount < noLicenseAccounts.length
    ) {
      setIsLicensesOpen(true);
    } else {
      setAction(action);
      setIsOpen(true);
    }
  }

  const triggerComponent = (
    <Button variant="secondary-purple" leftIcon={<GearSix />}>
      Manage accounts
    </Button>
  );

  const Component = isDesktop ? DesktopDropdown : MobileDrawer;

  return (
    <RestrictedComponent visibleForPermissions={["accounts_full"]}>
      <Component
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        action={action}
        setAction={onActionChange}
        selectedAccounts={selectedAccounts}
      >
        {triggerComponent}
      </Component>

      <Licenses
        isOpen={isLicensesOpen}
        setIsOpen={setIsLicensesOpen}
        newSeatsCount={noLicenseAccounts.length}
      />
    </RestrictedComponent>
  );
}
